module.exports = __webpack_public_path__ + "img/T4-A-rc_14.75d41c50.png";